module.exports = __webpack_public_path__ + "img/unknownPackage.3c372dcf.svg";